'use client';

import { type ReactNode } from 'react';
import { AuthProvider } from './auth-provider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from '@/components/providers/posthog-provider';
import { SidebarProvider } from '@/components/ui/sidebar';

const queryClient = new QueryClient();

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <PostHogProvider>
          <SidebarProvider>{children}</SidebarProvider>
        </PostHogProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}
